import $ from "jquery";
import select2        from "select2"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"
import moment from 'moment'
import 'moment-timezone'
import 'moment-timezone/builds/moment-timezone-with-data-2012-2022.min.js'

const applyLocalTimeZone = function() {
  const country = document.querySelector('.sort-by-country').value
  let timeZone = ''
  let tenderStartTime = document.querySelector('input.tender_start_time').value
  let tenderEndTime = document.querySelector('input.tender_end_time').value

  if (tenderStartTime != '') {
    tenderStartTime = (new Date(tenderStartTime)).toString()
  } else {
    tenderStartTime = new Date()
  }

  if (tenderEndTime != '') {
    tenderEndTime = (new Date(tenderEndTime)).toString()
  } else {
    tenderEndTime = new Date()
  }

  switch (country) {
    case 'Australia':
      timeZone = 'Australia/Sydney';
      break;
    case 'New Zealand':
      timeZone = 'Pacific/Auckland';
      break;
  }

  updateDateTimePicker.call(this, timeZone)

  if (country == '') {
    document.querySelector('input.tender_start_time').value = ''
    document.querySelector('input.tender_end_time').value = ''
  }
}

const updateDateTimePicker = function(timeZone) {
  $("#tender_start_time").data("DateTimePicker").destroy()
  $("#tender_end_time").data("DateTimePicker").destroy()

  $("#tender_start_time").datetimepicker({
    format: 'YYYY/MM/D hh:mm A z',
    timeZone: timeZone
  });

  $("#tender_end_time").datetimepicker({
    format: 'YYYY/MM/D hh:mm A z',
    timeZone: timeZone
  });
}

export default applyLocalTimeZone;
